import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['fr', 'de', 'en', 'es', 'it', 'nl', 'pt'],
  // The `pathnames` object holds pairs of internal and
  // external paths. Based on the locale, the external
  // paths are rewritten to the shared, internal ones.
  pathnames: {
    // If all locales use the same pathname, a single
    // external path can be used for all locales
    '/': '/',
    '/about': {
      de: '/uber-uns',
      en: '/about',
      es: '/acerca-de',
      it: '/chi-siamo',
      nl: '/over-ons',
      pt: '/sobre',
    },

    '/agence-de-voyage-velo': {
      de: '/fahrrad-reisebüro',
      en: '/bike-travel-agency',
      es: '/agencia-viajes-bicicleta',
      it: '/agenzia-viaggi-bicicletta',
      nl: '/fiets-reisbureau',
      pt: '/agencia-viagens-bicicleta',
    },

    '/agence-de-voyage-velo/[slug]': {
      de: '/fahrrad-reisebüro/[slug]',
      en: '/bike-travel-agency/[slug]',
      es: '/agencia-viajes-bicicleta/[slug]',
      it: '/agenzia-viaggi-bicicletta/[slug]',
      nl: '/fiets-reisbureau/[slug]',
      pt: '/agencia-viagens-bicicleta/[slug]',
    },
    '/cgu': '/cgu',

    '/conseils-inspirations': {
      de: '/reise-tipps',
      en: '/tips-inspirations',
      es: '/consejos-inspiraciones',
      it: '/consigli-inspirazioni',
      nl: '/tips-inspiraties',
      pt: '/dicas-inspiracoes',
    },

    '/conseils-inspirations/[slug]': {
      de: '/reise-tipps/[slug]',
      en: '/tips-inspirations/[slug]',
      es: '/consejos-inspiraciones/[slug]',
      it: '/consigli-inspirazioni/[slug]',
      nl: '/tips-inspiraties/[slug]',
      pt: '/dicas-inspiracoes/[slug]',
    },

    '/contact': {
      de: '/kontakt',
      en: '/contact',
      es: '/contacto',
      it: '/contatto',
      nl: '/contact',
      pt: '/contato',
    },

    '/privacy-policy': {
      de: '/datenschutz',
      en: '/privacy-policy',
      es: '/política-de-privacidad',
      it: '/politica-di-privacy',
      nl: '/privacy-beleid',
    },
    '/mentions-legales': {
      de: '/impressum',
      en: '/legal-notice',
      es: '/aviso-legal',
      it: '/avviso-legale',
      nl: '/algemene-voorwaarden',
    },

    '/profile/[...profile]': {
      de: '/profil/[...profile]',
      en: '/profile/[...profile]',
      es: '/perfil/[...profile]',
      it: '/profilo/[...profile]',
      nl: '/profiel/[...profile]',
      pt: '/perfil/[...profile]',
    },

    '/locations': {
      de: '/fahrradverleih',
      en: '/bike-rentals',
      es: '/alquiler-bicicletas',
      it: '/noleggio-bici',
      nl: '/fietsverhuur',
      pt: '/aluguer-bicicletas',
    },
    '/locations/[slug]': {
      de: '/fahrradverleih/[slug]',
      en: '/bike-rentals/[slug]',
      es: '/alquiler-bicicletas/[slug]',
      it: '/noleggio-bici/[slug]',
      nl: '/fietsverhuur/[slug]',
      pt: '/aluguer-bicicletas/[slug]',
    },
    '/locations/book/[slug]': {
      de: '/fahrradverleih/buchung/[slug]',
      en: '/bike-rentals/booking/[slug]',
      es: '/alquiler-bicicletas/reserva/[slug]',
      it: '/noleggio-bici/prenotazione/[slug]',
      nl: '/fietsverhuur/reservering/[slug]',
      pt: '/aluguer-bicicletas/reserva/[slug]',
    },
    '/locations/cart': {
      de: '/fahrradverleih/wagen',
      en: '/bike-rentals/cart',
      es: '/alquiler-bicicletas/carrito',
      it: '/noleggio-bici/carrello',
      nl: '/fietsverhuur/wagen',
      pt: '/aluguer-bicicletas/carrinho',
    },

    '/locations-electrique': {
      de: '/elektro-standorte',
      en: '/electric-locations',
      es: '/ubicaciones-electricas',
      it: '/posizioni-elettriche',
      nl: '/elektrische-locaties',
      pt: '/localizacoes-eletricas',
    },

    '/locations-cargo': {
      de: '/cargo-standorte',
      en: '/cargo-locations',
      es: '/ubicaciones-carga',
      it: '/posizioni-cargo',
      nl: '/cargo-locaties',
      pt: '/localizacoes-carga',
    },
  },
  // Used when no locale matches
  defaultLocale: 'fr',
});

export function getLocalizedPath(internalPath: string, locale: string): string {
  const pathConfig =
    routing.pathnames[internalPath as keyof typeof routing.pathnames];

  if (typeof pathConfig === 'string') {
    return pathConfig;
  }

  if (pathConfig && typeof pathConfig === 'object' && locale in pathConfig) {
    return pathConfig[locale as keyof typeof pathConfig] as string;
  }

  // Fallback to internal path if no translation found
  return internalPath;
}
